import * as React from "react";

import { PageWrapper } from "@/components/PageWrapper";
import { HeathStats } from "./components/HealthStats";
import { Leaderboards } from "./components/Leaderboards";

export const Dashboard: React.FC = () => {
  return (
    <PageWrapper title="Stats" hideSeparator className="coachDashboard">
      <HeathStats />
      <Leaderboards />
    </PageWrapper>
  );
};
